// extracted by mini-css-extract-plugin
module.exports = {"cards":"styles_cards__3v2go","header":"styles_header__deF1T","searchHeadingWrapper":"styles_searchHeadingWrapper__YtreM"};